import React from 'react';
import { GlobalChatWidget } from '../GlobalChatWidget';
import { ChatOperationsDashboard } from '../ChatOperationsDashboard';
import { ChatCommandCenterDashboard } from '../ChatCommandCenterDashboard';
import { ChatAutomationRulesPanel } from '../ChatAutomationRulesPanel';
import { ChatBroadcastCenter } from '../ChatBroadcastCenter';
import { ChatKnowledgeBasePanel } from '../ChatKnowledgeBasePanel';
import { ChatExecutiveInsightsDashboard } from '../ChatExecutiveInsightsDashboard';
import { ChatReportBuilder } from '../ChatReportBuilder';
import { ChatSatisfactionPanel } from '../ChatSatisfactionPanel';
import { ChatOmnichannelInbox } from '../ChatOmnichannelInbox';

/**
 * Rotas sugeridas para plugar no React Router do projeto.
 * Ajuste wrappers, guards e layout conforme a estrutura real do Aluno Conectado.
 */
export const chatPremiumRoutes = [
  { path: '/master/chat', element: <ChatOmnichannelInbox /> },
  { path: '/master/chat/atendimentos', element: <ChatOperationsDashboard /> },
  { path: '/master/chat/comando', element: <ChatCommandCenterDashboard /> },
  { path: '/master/chat/automacoes', element: <ChatAutomationRulesPanel /> },
  { path: '/master/chat/comunicados', element: <ChatBroadcastCenter /> },
  { path: '/master/chat/conhecimento', element: <ChatKnowledgeBasePanel /> },
  { path: '/master/chat/insights', element: <ChatExecutiveInsightsDashboard /> },
  { path: '/master/chat/relatorios', element: <ChatReportBuilder /> },
  { path: '/master/chat/satisfacao', element: <ChatSatisfactionPanel /> },
];

export function ChatWidgetMountExample() {
  const [open, setOpen] = React.useState(false);
  const [docked, setDocked] = React.useState(false);
  const [unread, setUnread] = React.useState(0);

  return (
    <GlobalChatWidget
      isOpen={open}
      onClose={() => setOpen(false)}
      isDocked={docked}
      onToggleDock={() => setDocked((v) => !v)}
      chatUnreadCount={unread}
      setChatUnreadCount={setUnread}
    />
  );
}
